export default __webpack_public_path__ + "static/media/hht1_ep13_minisitcom_01.2ba401c9.png";